import { render, staticRenderFns } from "./ClassStudy.vue?vue&type=template&id=503d433e&scoped=true&"
import script from "./classstudy.js?vue&type=script&lang=js&"
export * from "./classstudy.js?vue&type=script&lang=js&"
import style0 from "./ClassStudy.vue?vue&type=style&index=0&id=503d433e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d433e",
  null
  
)

export default component.exports